/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AlexandriaCandidate = {
  alexandria_id: string;
  display_name: string;
  match_type: AlexandriaCandidate.match_type;
};
export namespace AlexandriaCandidate {
  export enum match_type {
    DOMAIN = 'domain',
    NAME = 'name',
  }
}

